import { FormikValues } from "formik";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import { SelectItem } from "primereact/selectitem";
import { getFormErrorMessage } from "../../utils/formHelper";
import { useState } from "react";

type Props = {
    disabled: boolean;
    formik: FormikValues;
    label: string;
    options: SelectItem[];
    splitter: string;
    value: string;
}

export const FormMultiSelect = (props: Props) => {
    const { disabled, formik, label, options, splitter, value } = props;

    const [values, setValues] = useState(formik.values[value] ? formik.values[value].split(splitter) : []);

    const onChange = (event: MultiSelectChangeEvent) => {
        const newValues = event.value;

        setValues(newValues);

        formik.setFieldValue(value, newValues.join(splitter));
    }

    return (
        <div className="field">
            <span className="p-float-label">
                <MultiSelect id={value} name={value} value={values} disabled={disabled}
                    onChange={onChange} options={options} className="w-full" scrollHeight="400px" />
                <label htmlFor={value}>{label}</label>
            </span>
            {getFormErrorMessage(value, formik)}
        </div>
    )
}